import React, { useState } from 'react';

export default function LoginForm({ onAuth }) {
  const [user, setUser] = useState('');
  const [pass, setPass] = useState('');

  const submit = e => {
    e.preventDefault();
    fetch('/api/login', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ user, pass })
    })
      .then(r => {
        if (!r.ok) throw new Error('Bad creds');
        return r.json();
      })
      .then(data => onAuth(data.token))
      .catch(() => alert('Invalid username or password'));
  };

  const inputStyle = { padding: 10, borderRadius: 8, border: '1px solid var(--border)', background: 'var(--surface)', color: 'var(--text)', width: '100%', maxWidth: 360 };
  const btnStyle = { padding: '10px 14px', borderRadius: 20, border: 'none', background: 'var(--accent)', color: 'var(--accent-contrast)', fontWeight: 700, cursor: 'pointer' };
  return (
    <form onSubmit={submit} style={{ padding: 20, maxWidth: 520, margin: '40px auto', color: 'var(--text)' }}>
      <h2 style={{ color: 'var(--accent)', marginBottom: 12 }}>Admin Login</h2>
      <div>
        <input
          placeholder="Username"
          value={user}
          onChange={e => setUser(e.target.value)}
          style={inputStyle}
        />
      </div>
      <div style={{ marginTop: 8 }}>
        <input
          type="password"
          placeholder="Password"
          value={pass}
          onChange={e => setPass(e.target.value)}
          style={inputStyle}
        />
      </div>
      <button type="submit" style={{ ...btnStyle, marginTop: 12 }}>Log In</button>
    </form>
  );
}
